
import toastr from "toastr";
import "toastr/build/toastr.min.css";

export const showNotification=(toastType,message)=>{
 toastr.options = {
      positionClass:  "toast-top-right",
      timeOut: '8000',
      extendedTimeOut: '1000',
      showEasing: 'swing',
      hideEasing: 'linear',
      showMethod: 'fadeIn',
      hideMethod: 'fadeOut',
      showDuration: '300',
      hideDuration: '1000'
    };

    if (toastType === "info") toastr.info(message);
    else if (toastType === "warning") toastr.warning(message);
    else if (toastType === "error") toastr.error(message);
    else toastr.success(message);
  
}